import { Skeleton } from "@mui/material";

import { InsightsProperty } from "graphql-types/graphql";
import { useStreetViewImage } from "legacyNext/hooks";

type Props = {
    latitude: InsightsProperty["latitude"];
    longitude: InsightsProperty["longitude"];
};

export const AssetAvatar = (props: Props) => {
    const { latitude, longitude } = props;
    const streetView = useStreetViewImage({
        latitude: latitude ?? 0,
        longitude: longitude ?? 0,
        width: 223,
        height: 223,
    });

    if (!streetView.url) {
        return (
            <Skeleton
                variant="rectangular"
                width={streetView.width}
                height={streetView.height}
            />
        );
    }

    return (
        <img
            src={streetView.url}
            width={streetView.width}
            height={streetView.height}
            alt={streetView.url}
        />
    );
};
